// Product Sidebar on scroll
const sidebar = document.querySelector("#boxThis");
const sidebarOffset = sidebar.offsetTop;
var Sidebar = (function() {
    var Sidebar = {
        addEvents: function() {
            window.addEventListener("scroll", this.check.bind(this));
        },
        init: function() {
            this.addEvents();
        },
        check: function(event) {
            if (window.pageYOffset >= sidebarOffset - (177)) {
                sidebar.classList.add("sticky");
            } else {
                sidebar.classList.remove("sticky");
            }
        }
    };
    return Sidebar;
})();
Sidebar.init();
